import React from 'react';
import InsurerPhone from '../../../util/InsurerPhone';
import { ACCOUNT_CALL_INSURANCE_BENEFITS } from '../../../../../../../core/analytics/events';
import { Content } from './shared';

type Props = {
  benefitsPhone: string;
  insuranceCarrierDisplayProperties: any;
  insuranceProfile: any;
};

const UniversalBreastPump = (props: Props) => {
  const { benefitsPhone, insuranceCarrierDisplayProperties, insuranceProfile } = props;
  return (
    <Content>
      Many plans offer a free breast pump if you're expecting or recently had a baby. Call member
      services at{' '}
      {benefitsPhone && (
        <span>
          <InsurerPhone
            insuranceCarrierDisplayProperties={insuranceCarrierDisplayProperties}
            insuranceCarrierName={insuranceProfile.insurer_name}
            insurerCode={insuranceProfile.insurer_code}
            insurerPhone={benefitsPhone}
            insurerType={insuranceProfile.insurer_type}
            trackingCode={ACCOUNT_CALL_INSURANCE_BENEFITS}
          />{' '}
        </span>
      )}
      to learn more. Some helpful questions to ask:
      <ol>
        <li>What type of pumps (manual, electric, hospital-grade, etc.) are available to me?</li>

        <li>What vendors can I buy my pump from?</li>

        <li>Will I need a doctor's prescription for my pump?</li>
      </ol>
    </Content>
  );
};

export default UniversalBreastPump;
